import { SubmitClaim } from "commonAssets/js/submit-claim";
import { createElement } from "commonAssets/lib/createElement";
import { clearMessage } from "commonAssets/lib/clearMessage";
import { localDatetime } from "commonAssets/lib/localDatetime";
import { ConfirmEmailAddress } from "commonAssets/lib/ConfirmEmailAddress";
import { toggleFieldError } from "commonAssets/lib/toggleFieldError";
import { validPrice } from "commonAssets/lib/validPrice";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { loadMember } from "commonAssets/lib/loadMember";
import { modal } from "commonAssets/lib/modal";
import { toggleFieldAttribute } from "commonAssets/lib/toggleFieldAttribute";
import { validateField } from "commonAssets/lib/validateField";
import { appPayMethod, i18n, reCAPTCHAv3, outputDiv } from "commonAssets/js/constants";
import { OptOut } from "../../../common/assets/js/submit-claim";
import { ErrorHandler } from "../../../common/assets/js/classes";

export class customSubmitClaim extends SubmitClaim {
    claim_form(params) {
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, [
            this.claim_instructions(params),
            this.claim_contact_information(params),
            createElement("div", { id: "claim-fields" }, [], `        
            <fieldset class="mb-4">
                <p class="text-decoration-underline text-center mb-5" style="font-size: 24px;" id="claim_option"><strong>You may select ONE of the following options: <span class="error"></span></strong></p>

                <h4>III.	CREDIT MONITORING AND INSURANCE SERVICES (“CMIS”)</h4>
        
                <div class="row mb-5">
                    <div class="col">
                        <div class="form-check">
                            <input type="radio" class="form-check-input toggleCtrl" name="claim_option" id="claim_option_cm" value="Credit Monitoring" data-validate="required" data-custom-validate data-label="Claim Option">
                            <label for="claim_option_cm">If you wish to receive Credit Monitoring and Insurance Services, you must check off the box for this section, provide your email address in the space provided in Section II, above, and return this Claim Form. Submitting this Claim Form will not automatically enroll you into Credit Monitoring and Insurance Services. To enroll, you must follow the instructions sent to your email address after the Settlement is approved and becomes final (the “Effective Date”). You do not need to submit any additional documents if you are electing this category, so long as you provide your Unique ID Number that was provided on your mailed Notice. <span class="error"></span></label>
                        </div>
                    </div>
                </div>

                <h4 class="text-decoration-underline">OR</h4>
        
                <h4>IV.	REIMBURSEMENT FOR DOCUMENTED LOSSES</h4>

                <div class="row mb-5">
                    <div class="col">
                        <div class="form-check">
                            <input type="radio" class="form-check-input toggleCtrl" name="claim_option" id="claim_option_r" value="Reimbursement For Documented Losses" data-validate="required" data-custom-validate data-label="Claim Option">
                            <label for="claim_option_r">Please check off this box for this section if you are electing to seek reimbursement for up to $5,000 of Documented Losses you incurred that are more likely than not a result of the Onix Data Incident. Documented Losses include unreimbursed losses and consequential expenses that more likely than not resulted from the Onix Data Incident and were incurred on or after March 27, 2023. <span class="error"></span></label>
                        </div>
                    </div>
                </div>
        
                <div id="reimbursement-fields" class="mt-3 ms-4 d-none">
                <p>In order to make a claim for a Documented Loss Payment, <strong class='text-decoration-underline'>you must</strong> (i) fill out the information below and/or on a separate sheet submitted with this Claim Form; (ii) sign the attestation at the end of this Claim Form (section VII); and (iii) include Reasonable Documentation supporting each claimed cost along with this Claim Form. Documented Losses need to be deemed more likely than not due to the Onix Data Incident by the Settlement Administrator based on the documentation you provide and the facts of the Onix Data Incident. <strong class="text-decoration-underline">Failure to meet the requirements of this section may result in your claim being rejected by the Settlement Administrator.</strong></p>
        
                <table>
                    <thead>
                        <tr>
                            <th><strong>Cost Type</strong><br>(Fill all that apply)</th>
                            <th><strong>Approximate Date of Loss</strong></th>
                            <th><strong>Amount of Loss</strong></th>
                            <th><strong>Description of Supporting Reasonable Documentation</strong><br>(Identify what you are attaching and why)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <input type="checkbox" class="form-check-input toggleCtrl" name="unreimbursed_fraud_losses" id="unreimbursed_fraud_losses" value="Yes" data-validate="" data-label="Q4.1.1: Unreimbursed fraud losses or charges" disabled>
                                <label for="unreimbursed_fraud_losses">Unreimbursed fraud losses or charges <span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="date" name="unreimbursed_fraud_losses_date" id="unreimbursed_fraud_losses_date" placeholder="MM/DD/YYYY" min="2023-03-27" data-date-min="2023-03-27" data-validate="date date-min" data-label="Q4.1.2: Approximate Date of Loss" disabled />
                                <label for="unreimbursed_fraud_losses_date"><span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="number" name="unreimbursed_fraud_losses_amount" id="unreimbursed_fraud_losses_amount" min="0.01" max="5000" step="any" data-validate="price" data-custom-validate data-label="Q4.1.3: Amount of Loss" disabled />
                                <label for="unreimbursed_fraud_losses_amount"><span class="error"></span></label>
                            </td>
                            <td>
                                <label for="unreimbursed_fraud_losses_description"><em>Examples: Account statement with unauthorized charges highlighted; Correspondence from financial institution declining to reimburse you for fraudulent charges</em> <span class="error"></span></label>
                                <textarea maxlength="500" rows="3" class="form-control" name="unreimbursed_fraud_losses_description" id="unreimbursed_fraud_losses_description" data-validate="" data-label="Q4.1.4: Description" disabled></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="checkbox" class="form-check-input toggleCtrl" name="professional_fees" id="professional_fees" value="Yes" data-validate="" data-label="Q4.2.1: Professional fees incurred" disabled>
                                <label for="professional_fees">Professional fees incurred in connection with identity theft or falsified tax returns <span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="date" name="professional_fees_date" id="professional_fees_date" placeholder="MM/DD/YYYY" min="2023-03-27" data-date-min="2023-03-27" data-validate="date date-min" data-label="Q4.2.2: Approximate Date of Loss" disabled />
                                <label for="professional_fees_date"><span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="number" name="professional_fees_amount" id="professional_fees_amount" min="0.01" max="5000" step="any" data-validate="price" data-custom-validate data-label="Q4.2.3: Amount of Loss" disabled />
                                <label for="professional_fees_amount"><span class="error"></span></label>
                            </td>
                            <td>
                                <label for="professional_fees_description"><em>Examples: Receipt for hiring service to assist you in addressing identity theft; Accountant bill for re-filing tax return</em> <span class="error"></span></label>
                                <textarea maxlength="500" rows="3" class="form-control" name="professional_fees_description" id="professional_fees_description" data-validate="" data-label="Q4.2.4: Description" disabled></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="checkbox" class="form-check-input toggleCtrl" name="lost_interest" id="lost_interest" value="Yes" data-validate="" data-label="Q4.3.1: Lost interest" disabled>
                                <label for="lost_interest">Lost interest or other damages resulting from a delayed state and/or federal tax refund in connection with fraudulent tax return filing <span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="date" name="lost_interest_date" id="lost_interest_date" placeholder="MM/DD/YYYY" min="2023-03-27" data-date-min="2023-03-27" data-validate="date date-min" data-label="Q4.3.2: Approximate Date of Loss" disabled />
                                <label for="lost_interest_date"><span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="number" name="lost_interest_amount" id="lost_interest_amount" min="0.01" max="5000" step="any" data-validate="price" data-custom-validate data-label="Q4.3.3: Amount of Loss" disabled />
                                <label for="lost_interest_amount"><span class="error"></span></label>
                            </td>
                            <td>
                                <label for="lost_interest_description"><em>Examples: Letter from IRS or state about tax fraud in your name; Documents reflecting length of time you waited to receive your tax refund and the amount</em> <span class="error"></span></label>
                                <textarea maxlength="500" rows="3" class="form-control" name="lost_interest_description" id="lost_interest_description" data-validate="" data-label="Q4.3.4: Description" disabled></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="checkbox" class="form-check-input toggleCtrl" name="credit_freeze" id="credit_freeze" value="Yes" data-validate="" data-label="Q4.4.1: Credit freeze" disabled>
                                <label for="credit_freeze">Credit freeze <span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="date" name="credit_freeze_date" id="credit_freeze_date" placeholder="MM/DD/YYYY" min="2023-03-27" data-date-min="2023-03-27" data-validate="date date-min" data-label="Q4.4.2: Approximate Date of Loss" disabled />
                                <label for="credit_freeze_date"><span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="number" name="credit_freeze_amount" id="credit_freeze_amount" min="0.01" max="5000" step="any" data-validate="price" data-custom-validate data-label="Q4.4.3: Amount of Loss" disabled />
                                <label for="credit_freeze_amount"><span class="error"></span></label>
                            </td>
                            <td>
                                <label for="credit_freeze_description"><em>Examples: Notices or account statements reflecting payment for a credit freeze</em> <span class="error"></span></label>
                                <textarea maxlength="500" rows="3" class="form-control" name="credit_freeze_description" id="credit_freeze_description" data-validate="" data-label="Q4.4.4: Description" disabled></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="checkbox" class="form-check-input toggleCtrl" name="credit_monitoring" id="credit_monitoring" value="Yes" data-validate="" data-label="Q4.5.1: Credit monitoring" disabled>
                                <label for="credit_monitoring">Credit monitoring that was ordered after March 27, 2023 through the date on which the Credit Monitoring and Insurance Services become available through this Settlement <span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="date" name="credit_monitoring_date" id="credit_monitoring_date" placeholder="MM/DD/YYYY" min="2023-03-27" data-date-min="2023-03-27" data-validate="date date-min" data-label="Q4.5.2: Approximate Date of Loss" disabled />
                                <label for="credit_monitoring_date"><span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="number" name="credit_monitoring_amount" id="credit_monitoring_amount" min="0.01" max="5000" step="any" data-validate="price" data-custom-validate data-label="Q4.5.3: Amount of Loss" disabled />
                                <label for="credit_monitoring_amount"><span class="error"></span></label>
                            </td>
                            <td>
                                <label for="credit_monitoring_description"><em>Examples: Receipts or account statements reflecting purchases made for credit monitoring and insurance services</em> <span class="error"></span></label>
                                <textarea maxlength="500" rows="3" class="form-control" name="credit_monitoring_description" id="credit_monitoring_description" data-validate="" data-label="Q4.5.4: Description" disabled></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="checkbox" class="form-check-input toggleCtrl" name="miscellaneous_expenses" id="miscellaneous_expenses" value="Yes" data-validate="" data-label="Q4.6.1: Miscellaneous expenses" disabled>
                                <label for="miscellaneous_expenses">Miscellaneous expenses such as notary, fax, postage, copying, mileage, and long- distance telephone charges <span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="date" name="miscellaneous_expenses_date" id="miscellaneous_expenses_date" placeholder="MM/DD/YYYY" min="2023-03-27" data-date-min="2023-03-27" data-validate="date date-min" data-label="Q4.6.2: Approximate Date of Loss" disabled />
                                <label for="miscellaneous_expenses_date"><span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="number" name="miscellaneous_expenses_amount" id="miscellaneous_expenses_amount" min="0.01" max="5000" step="any" data-validate="price" data-custom-validate data-label="Q4.6.3: Amount of Loss" disabled />
                                <label for="miscellaneous_expenses_amount"><span class="error"></span></label>
                            </td>
                            <td>
                                <label for="miscellaneous_expenses_description"><em>Examples: Phone bills, gas receipts, postage receipts; detailed list of locations to which you traveled (i.e. police station, IRS office), indication of why you traveled there (i.e. police report or letter from IRS re: falsified tax return) and number of miles you traveled to remediate or address issues related to the Onix Data Incident</em> <span class="error"></span></label>
                                <textarea maxlength="500" rows="3" class="form-control" name="miscellaneous_expenses_description" id="miscellaneous_expenses_description" data-validate="" data-label="Q4.6.4: Description" disabled></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="checkbox" class="form-check-input toggleCtrl" name="other" id="other" value="Yes" data-validate="" data-label="Q4.7.1: Other" disabled>
                                <label for="other">Other (provide detailed description) <span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="date" name="other_date" id="other_date" placeholder="MM/DD/YYYY" min="2023-03-27" data-date-min="2023-03-27" data-validate="date date-min" data-label="Q4.7.2: Approximate Date of Loss" disabled />
                                <label for="other_date"><span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="number" name="other_amount" id="other_amount" min="0.01" max="5000" step="any" data-validate="price" data-custom-validate data-label="Q4.7.3: Amount of Loss" disabled />
                                <label for="other_amount"><span class="error"></span></label>
                            </td>
                            <td>
                                <p><em>Please provide a detailed description in a separate document submitted with this Claim Form</em></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="checkbox" class="form-check-input toggleCtrl" name="emotional_distress" id="emotional_distress" value="Yes" data-validate="" data-label="Q4.8.1: Settlement Benefits Related to Emotional Distress" disabled>
                                <label for="emotional_distress">Settlement Benefits Related to Emotional Distress <span class="error"></span></label>
                                <br><br>
                                <div id="medical-beneficiary-container" class="d-none">
                                    <input type="checkbox" class="form-check-input toggleCtrl" name="medicare_beneficiary" id="medicare_beneficiary" value="Yes" data-validate="" data-label="Q4.8.1a: Medicare Beneficiary" disabled>
                                    <label for="medicare_beneficiary">Check here <strong class="text-decoration-underline">only if</strong> you declare that you were a <span class="text-decoration-underline">Medicare beneficiary</span> during the time period of March 27, 2023 to the present and are seeking benefits in this Settlement related to emotional distress. If you were a Medicare beneficiary at any time during the period of March 27, 2023 to present and are seeking any reimbursement for emotional distress, please contact the Settlement Administrator at 1-888-897-2160 to provide additional information necessary for Medicare reporting requirements. <strong class="text-decoration-underline"><em>Leave this unchecked if either:</em></strong> (i) you were <strong class="text-decoration-underline">not</strong> a Medicare beneficiary during the time period of March 27, 2023 to the present; or (ii) if you were a Medicare beneficiary at any time during the period of March 27, 2023 to the present and are <strong class="text-decoration-underline">not</strong> seeking any reimbursement for emotional distress from this Settlement. <span class="error"></span></label>
                                </div>
                            </td>
                            <td>
                                <input class="form-control" type="date" name="emotional_distress_date" id="emotional_distress_date" placeholder="MM/DD/YYYY" min="2023-03-27" data-date-min="2023-03-27" data-validate="date date-min" data-label="Q4.8.2: Approximate Date of Loss" disabled />
                                <label for="emotional_distress_date"><span class="error"></span></label>
                            </td>
                            <td>
                                <input class="form-control" type="number" name="emotional_distress_amount" id="emotional_distress_amount" min="0.01" max="5000" step="any" data-validate="price" data-custom-validate data-label="Q4.8.3: Amount of Loss" disabled />
                                <label for="emotional_distress_amount"><span class="error"></span></label>
                            </td>
                            <td>
                                <p><em>Examples: Bills from medical providers or for medications prescribed for the treatment of emotional distress, anxiety, or other mental health disorders reasonably related to the conditions caused by the Data Incident between March 27, 2023 and the Claims Deadline</em></p>

                                <p><strong><em>Please attach a copy of your medical bills, pharmacy bills, or an explanation of benefit forms showing the out-of-pocket expenditures for treatment of emotional distress or anxiety.</em></strong></p>
                            </td>
                        </tr>
                    </tbody>
                </table>  
                <p class="mt-3"><strong>If you do not submit Reasonable Documentation supporting a Documented Loss Payment claim, or your claim for a Documented Loss Payment is rejected by the Settlement Administrator for any reason and you do not cure the defect, your claim will be considered for a Cash Fund Payment.</strong></p>
                </div>      

                <h4 class="text-decoration-underline">OR</h4>

                <h4>V. 	CASH FUND PAYMENT</h4>

                <div class="row">
                    <div class="col">
                        <div class="form-check">
                            <input type="radio" class="form-check-input toggleCtrl" name="claim_option" id="claim_option_cf" value="Cash Fund Payment" data-validate="required" data-custom-validate data-label="Claim Option">
                            <label for="claim_option_cf">If you wish to receive a Cash Fund Payment, you must check off the box for this section, and then simply return this Claim Form. You may also make a claim for a Cash Fund Payment by submitting to the Settlement Administrator the tear-off “Claim Form For Pro Rata Cash Fund Payment Only” you may have previously received by mail. You do not need to submit any additional documents if you are electing this category, so long as you provide your Unique ID Number that was provided on your mailed Notice. <span class="error"></span></label>
                        </div>
                    </div>
                </div>

                <div id="cf-fields" class="mt-3 ms-4 d-none">
                    <p>You will receive an email at the email address provided above after final approval of the Settlement prompting you to select how you would like to be paid. You can receive payment via a digital payment, or you can elect to receive a check.</p>
                </div>

                <input type="hidden" name="payment_method" id="payment_method" data-label="Payment Method" />
                <input type="hidden" name="payment_token" id="payment_token" data-label="Payment Token" />
                <input type="hidden" name="payment_email" id="payment_email" data-label="Payment Email" />
                <input type="hidden" name="payment_phone" id="payment_phone" data-label="Payment Phone" />
            </fieldset>`),
            params.claim_transactions ? this.claim_transactions(params) : ``,
            params.claim_upload.documentation.required ? this.claim_documentation(params) : ``,
            appPayMethod ? this.claim_payment_method(params) : ``,
            this.claim_certification(params),
            createElement("div", { id: `message1` }),
            createElement("div", { id: `message2` }),
            createElement("div", { id: `message3` }),
            createElement("div", { id: `message4` })
        ]);
        return form;
    }

    init_claim(form) {
        this.claim.api.claimsDeadlineGet({ domain: this.claim.data.domain }).then((result) => {

            // Claim Deadline - Default Pacific DateTime
            let datetime;
            if (Boolean(result.data.pacific_datetime)) {
                datetime = result.data.pacific_datetime;
            }
            else {
                datetime = `<pre>Error: datetime</pre>`;
            }

            let claim_deadline;
            if (Boolean(result.data.claim_deadline)) {
                claim_deadline = result.data.claim_deadline;
            }

            // Error Handling
            if (result.data.error) {
                this.setup_result_data_error(result);
                return;
            }

            const container = createElement("div", {
                class: "display-form",
            });

            /** 
             * Claim Guard
             */
            if (form.form_options.notice_confirmation.display === true) {

                // Guard
                container.appendChild(this.guard(form, datetime));
                outputDiv.appendChild(container);


                const zero_zero_id = document.getElementById('zero_zero_id');
                const confirmation_code = document.getElementById('confirmation_code');
                const skip_guard = document.getElementById("skip-guard");

                // Notice Id and Confirmation Code
                [zero_zero_id, confirmation_code].forEach(function (input) {
                    input.addEventListener('change', validateField);
                });

                // Skip Guard
                if (skip_guard) {
                    skip_guard.addEventListener("click", () => {
                        // Hide guard
                        document.getElementById('guard').classList.add("d-none");
                        // New Claim Form
                        container.appendChild(this.claim_form(form));
                        container.scrollIntoView({ behavior: "smooth" });
                        outputDiv.appendChild(container);

                        // Init claim fields
                        this.init_claim_fields(this.claim, form, claim_deadline);
                    });
                }

                // ada compliance updates - added
                // if input#submit-guard was clicked add .was-verified to form#guard 
                document.getElementById("submit-guard").addEventListener('click', () => {
                    document.getElementById("guard").classList.add("was-validated");
                    // TODO: add required text to labels
                });

                // Validate Guard Fields
                document.getElementById("guard").addEventListener("submit", (e) => {

                    e.preventDefault();

                    var valid = true;
                    var member = {
                        domain: this.claim.data.domain,
                        zero_zero_id: zero_zero_id.value.toUpperCase(),
                        confirmation_code: confirmation_code.value,
                    };

                    clearMessage();

                    // Validate guard fields
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        valid = validateField(input) && valid;
                    });
                    if (!valid) return;

                    loadingGif(loading, "show");

                    // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                    this.claim.api.classMemberPost({}, member).then((result) => {

                        // Check for error message
                        if (result.data.error) {
                            toggleFieldError(zero_zero_id, true, '');
                            toggleFieldError(confirmation_code, true, '');
                            modal(i18n.getTranslation('error'), `<p class="fw-bold">${result.data.error}</p>`);
                            loadingGif(loading, "hide", 250);
                            return;
                        }

                        // Add notice id and confirmation code to claim data
                        this.claim.data.zero_zero_id = member.zero_zero_id;
                        this.claim.data.confirmation_code = member.confirmation_code;

                        // Define the environment for the OTP
                        let environment = this.claim.data.domain.split('.')[0]; // ada compliance - added

                        // Check for existing claim number and add to claim data
                        if (result.data.claim_id) { // ada compliance - changed
                            // if (result.data.claim_type == 'opt-out') {
                            //     toggleFieldError(zero_zero_id, true, '');
                            //     toggleFieldError(confirmation_code, true, '');
                            //     modal(i18n.getTranslation('error'), `<p class="fw-bold">An opt-out form has already been submitted with this login.</p>`);
                            //     loadingGif(loading, "hide", 250);
                            //     return;
                            // }
                            this.claim.data.claim_id = result.data.claim_id;
                            this.send_otp(form, container, result.data, claim_deadline);
                            return;
                        }

                        // ada compliance updates - added
                        // Evoke the customLoadMember function, then pass the result.data to the customLoadMember function
                        if (this.customLoadMember != null) {
                            this.customLoadMember(result.data);
                        }

                        // Populate claim form
                        this.populate_claim_form(form, container, result.data, claim_deadline);

                    }).catch(function (error) {
                        const e = new ErrorHandler("init_claim_catch");
                        e.display(error);
                    });
                });
            }
            /**
             * No Claim Guard
             */
            else {
                // Edit claim link
                this.edit_claim(form);

                // New Claim Form
                container.appendChild(this.claim_form(form));
                outputDiv.appendChild(container);

                // Init claim fields
                this.init_claim_fields(this.claim, form, claim_deadline);
            }
            loadingGif(loading, "hide", 250)

        }).catch(function (error) {
            const e = new ErrorHandler();
            e.display(error);
        });
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        // Hide guard
        document.getElementById('guard').classList.add("d-none");

        // New Claim Form
        container.appendChild(this.claim_form(form));
        container.scrollIntoView({ behavior: "smooth" });
        outputDiv.appendChild(container);

        loadingGif(loading, "hide", 250);

        // Load member data into form
        loadMember(class_member);

        if (class_member.claim_id) {
            if (document.getElementById('claim_option_r').checked) {
                document.getElementById('reimbursement-fields').classList.remove('d-none');

                $('#reimbursement-fields input[type="checkbox"]').each(function() {
                    $(this).attr('disabled', false);
                });

                $('#reimbursement-fields input[type="checkbox"]:not(#medicare_beneficiary)').each(function() {
                    if ($(this).prop('checked')) {
                        $('#reimbursement-fields input[name^="'+this.id+'"]:not(#'+this.id+'), #reimbursement-fields textarea[name^="'+this.id+'"]').each(function() {
                            toggleField($(this), true);
                        });
                    }
                });

                if (document.getElementById('emotional_distress').checked) {
                    document.getElementById('medical-beneficiary-container').classList.remove('d-none');
                    document.getElementById('medicare_beneficiary').disabled = false;
                }
            }

            if (document.getElementById('claim_option_cf').checked) {
                document.getElementById('cf-fields').classList.remove('d-none');
            }

            if (document.getElementById('payment_method').value) {
                document.getElementById('dst-payment').classList.add('d-none');
                document.getElementById('previous_payment_method').innerText = document.getElementById('payment_method').value;
                document.getElementById('update_payment_toggle').addEventListener('click', function () {
                    document.getElementById('update_payment_message').classList.add('d-none');
                    document.getElementById('dst-payment').classList.remove('d-none');
                });
                document.getElementById('update_payment_message').classList.remove('d-none');
            }

            if (class_member.claim_files && class_member.claim_files.length > 0) {
                this.prev_uploads = true;
            }

            toggleFieldAttribute(document.getElementById('date_of_birth'), 'required', false);
            document.getElementById('date_of_birth').parentElement.classList.add('d-none');

            document.getElementById('signature').value = '';
        }

        if (document.getElementById('first_name').value) document.getElementById('first_name').disabled = true;
        if (document.getElementById('middle_initial').value) document.getElementById('middle_initial').disabled = true;
        if (document.getElementById('last_name').value) document.getElementById('last_name').disabled = true;

        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    init_claim_inputs() {
        this.claim.inputs.contact = Array.from(document.querySelectorAll('#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #ag_SGUID'))
        this.claim.inputs.fields = Array.from(document.querySelectorAll("#claim-fields input, #claim-fields textarea, #claim-fields select, #date_of_birth"));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll("#transactions input, #transactions textarea, #transactions select"));

        document.getElementById('claim_option_cm').addEventListener('click', function() {
            document.getElementById('reimbursement-fields').classList.add('d-none');
            document.getElementById('cf-fields').classList.add('d-none');
            $('#reimbursement-fields input, #reimbursement-fields textarea').each(function() {
                toggleField($(this), false);
            });
            document.getElementById('medical-beneficiary-container').classList.add('d-none');
        });

        document.getElementById('claim_option_r').addEventListener('click', function() {
            document.getElementById('reimbursement-fields').classList.remove('d-none');
            document.getElementById('cf-fields').classList.add('d-none');
            $('#reimbursement-fields input[type="checkbox"]').each(function() {
                $(this).attr('disabled', false);
            });
        });

        document.getElementById('claim_option_cf').addEventListener('click', function() {
            document.getElementById('reimbursement-fields').classList.add('d-none');
            document.getElementById('cf-fields').classList.remove('d-none');
            $('#reimbursement-fields input, #reimbursement-fields textarea').each(function() {
                toggleField($(this), false);
            });
            document.getElementById('medical-beneficiary-container').classList.add('d-none');
        });

        $('#reimbursement-fields input[type="checkbox"]:not(#medicare_beneficiary)').each(function() {
            $(this).on('click', function() {
                let toggle = this.checked;
                $('#reimbursement-fields input[name^="'+this.id+'"]:not(#'+this.id+'), #reimbursement-fields textarea[name^="'+this.id+'"]').each(function() {
                    toggleField($(this), toggle);
                });
            });
        });

        document.getElementById('emotional_distress').addEventListener('click', function() {
            document.getElementById('medical-beneficiary-container').classList[!this.checked ? 'add' : 'remove']('d-none');
            if (this.checked) {
                document.getElementById('medicare_beneficiary').disabled = false;
            } else {
                toggleField($('#medicare_beneficiary'), false);
            }
        });

        let today = new Date().toISOString().split('T')[0];
        document.querySelectorAll('input[type="date"]').forEach(function(input) {
            input.setAttribute('max', today);
            input.setAttribute('data-date-max', today);
            toggleFieldAttribute(input, 'date-max', true);
        });
    }

    process_claim(e, claim, deadline) {
        console.log("process_claim init...")

        /**
         * Prevent the default form submission.
         * 
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         * 
         * Since: 2023.09.25
         * 
         * @returns {void}
         */
        document.getElementById('submit-claim').disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.claim.inputs.contact = Array.from(document.querySelectorAll('#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #ag_SGUID'))
        this.claim.inputs.fields = Array.from(document.querySelectorAll("#claim-fields input, #claim-fields textarea, #claim-fields select, #date_of_birth"));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll("#transactions input, #transactions textarea, #transactions select"));
        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById('documentation')) {
            this.process_claim_files(this.claim);
        }

        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('process', this.claim);
        }

        /**
         * Define the environment for the s3 uploader.
         */
        let s3env = this.config.url;

        let custom_errors = '';

        if (document.getElementById('claim_option_r').checked) {
            let option_selected = false
            $('#reimbursement-fields input[type="checkbox"]').each(function(index, input) {
                if (input.checked) {
                    option_selected = true;
                }
            });
            if (!option_selected) {
                custom_errors += '<br>Please select at least one option in section IV.';
                claim.flags.valid = false;
            }

            if (claim.uploads.length == 0 && !this.prev_uploads) {
                custom_errors += '<br>Please upload supporting documentation.';
                claim.flags.valid = false;
            }
        }

        if (!$('#payment_method').val() || !$('#payment_token').val()) {
            custom_errors += '<br>Please select a method of payment.';
            claim.flags.valid = false;
        }

        if (document.getElementById('email_address').value && document.getElementById('payment_email').value && document.getElementById('email_address').value.toLowerCase() != document.getElementById('payment_email').value.toLowerCase()) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_email_error')}`;
            claim.flags.valid = false;
        }
    
        if (document.getElementById('phone_number_1').value && document.getElementById('payment_phone').value && document.getElementById('phone_number_1').value.replace(/\D/g, '') != document.getElementById('payment_phone').value.replace(/\D/g, '')) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_phone_error')}`;
            claim.flags.valid = false;
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            var error = document.querySelector('input.is-invalid, #file-notice.error, #no-files.error, #documentation.error');
            let timeout = 0;
            if (error && typeof error.scrollIntoView == 'function') {
                error.scrollIntoView({ behavior: "smooth" });
                timeout = 500;
            }
            setTimeout(() => {
                modal(i18n.getTranslation('error'), i18n.getTranslation('claim_form_errors') + custom_errors);
            }, timeout);
        }
    }
}

export class customOptOut extends OptOut {
    claim_deadline(params, additionalParams) {

        const alert = `<p class="mb-0">${params.form_options.claim_deadline_alert.body}</p>`;
        const parser = new DOMParser();
        const string = parser.parseFromString(alert, "text/html");

        const date_string = string.querySelector("span");
        date_string.textContent = additionalParams;

        const div = createElement("div", {
            class: "alert alert-warning my-3 text-center",
            id: "claim_form_alert"
        }, [], string.body.innerHTML.replace('claims', 'opt-out'));

        return div;
    }

    init_exclusion_guard(form, container, datetime, exclusion_deadline) {

        // Guard
        container.appendChild(this.guard(form, datetime));
        outputDiv.appendChild(container);

        const zero_zero_id = document.getElementById('zero_zero_id');
        const confirmation_code = document.getElementById('confirmation_code');
        const skip_guard = document.getElementById("skip-guard");

        // Notice Id and Confirmation Code
        [zero_zero_id, confirmation_code].forEach(function (input) {
            input.addEventListener('change', validateField);
        });

        // Skip Guard
        if (skip_guard) {
            skip_guard.addEventListener("click", () => {
                // Hide guard
                document.getElementById('guard').classList.add("d-none");
                // New Claim Form
                container.appendChild(this.exclusion_form(form));
                container.scrollIntoView({ behavior: "smooth" });
                outputDiv.appendChild(container);

                // Initiate opt out fields
                this.init_exclusion_fields();

                // Submit form
                document.getElementById("form").addEventListener('submit', (process) => {
                    this.process_exclusion(process, this.exclusion, exclusion_deadline);
                });
            });
        }

        // Validate Guard Fields
        document.getElementById("guard").addEventListener("submit", (e) => {
            e.preventDefault();

            var valid = true;
            var member = {
                domain: this.claim.data.domain,
                zero_zero_id: zero_zero_id.value.toUpperCase(),
                confirmation_code: confirmation_code.value,
            };

            clearMessage();

            // Validate guard fields
            [zero_zero_id, confirmation_code].forEach(function (input) {
                valid = validateField(input) && valid;
            });
            if (!valid) return;

            loadingGif(loading, "show");

            // Retrieve class member data (use POST to pass notice id and confirmation code privately)
            this.claim.api.classMemberPost({}, member).then((result) => {

                // Check for error message
                if (result.data.error) {
                    toggleFieldError(zero_zero_id, true, '');
                    toggleFieldError(confirmation_code, true, '');
                    modal(i18n.getTranslation('error'), `<p class="fw-bold">${result.data.error}</p>`);
                    loadingGif(loading, "hide", 250);
                    return;
                }

                // Add notice id and confirmation code to claim data
                this.exclusion.data.zero_zero_id = member.zero_zero_id;
                this.exclusion.data.confirmation_code = member.confirmation_code;

                // Check for existing claim number and add to claim data
                if (result.data.claim_id) {
                    toggleFieldError(zero_zero_id, true, '');
                    toggleFieldError(confirmation_code, true, '');
                    modal(i18n.getTranslation('error'), `<p class="fw-bold">A form has already been submitted with this login.</p>`);
                    loadingGif(loading, "hide", 250);
                    return;
                    this.exclusion.data.claim_id = result.data.claim_id;
                }

                // Hide guard
                document.getElementById('guard').classList.add("d-none");

                // New Claim Form
                container.appendChild(this.exclusion_form(form));
                container.scrollIntoView({ behavior: "smooth" });
                outputDiv.appendChild(container);

                loadingGif(loading, "hide", 250);

                // Load member data into form
                loadMember(result.data);

                // Init claim fields
                this.init_exclusion_fields(this.exclusion, form);

                // Submit Exclusion
                document.getElementById("form").addEventListener('submit', (process) => {
                    this.process_exclusion(process, this.exclusion, exclusion_deadline);
                });

            }).catch(function (error) {
                const e = new ErrorHandler();
                e.display_modal(error);
            });
        });
    }

    exclusion_form(params) {
        // create the exclusion form
        const claimFormElems = [
            createElement("h3", {
                class: "text-center text-decoration-underline mb-3",
            }, [], params.form_options.exclusion_form.title),
            createElement("div", {
                class: "text-center mb-3",
            }, [], params.form_options.exclusion_form.body),
            this.claim_contact_information(params),
        ];
        // if the claim fields were enabled push to form
        if (this.enableClaimFields) {
            claimFormElems.push(this.claim_fieldset(params));
        }
        // if the transational table is enabled, push to form
        if (this.enableClaimTransactions) {
            claimFormElems.push(this.claim_transactions(params));
        }
        // push the attestation to the form
        claimFormElems.push(this.claim_certification(params.form_options.exclusion_form));
        // build the form and add elements
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, claimFormElems);
        // return the html form
        return form;
    }

    claim_contact_information(params) {
        let d_none = (Boolean(params.form_options.claim_form.contact_information.body)) ? "" : " d-none";
        const fieldset = createElement("fieldset", {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: "contact-information",
        }, [
            createElement("legend", { class: "mb-3" }, [], params.form_options.claim_form.contact_information.title.replaceAll('II.', '').replaceAll('CLAIMANT', 'CONTACT')),
            this.claim_contact_fields(params),
        ]);
        return fieldset;
    }

    init_exclusion_fields(params) {
        this.exclusion.inputs = Array.from(document.querySelectorAll('#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn,#referer_url, #user_language, #ag_SGUID'));
        this.exclusion.inputs.transactions = Array.from(document.querySelectorAll("#transactions input, #transactions textarea, #transactions select"));

        this.exclusion.inputs.forEach(function (field) {
            // Check for validation attribute
            if (field.hasAttribute('data-validate')) {
                // Attach change event handler for validation
                field.addEventListener('change', function (e) {
                    validateField(field);
                });
            }
        })

        if (this.exclusion.inputs.transactions && this.exclusion.inputs.transactions.length > 0) {
            this.exclusion.inputs.transactions.forEach(function (field) {
                // Check for validation attribute
                if (field.hasAttribute('data-validate')) {
                    // Attach change event handler for validation
                    field.addEventListener('change', function (e) {
                        validateField(field);
                    });
                }
            });
        }

        // Validate phone number
        this.setup_phone_number_validation();

        // Country field toggle
        this.setup_country_field_toggle();

        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('init');
        }

        toggleFieldAttribute(document.getElementById('date_of_birth'), 'required', false);
        document.getElementById('date_of_birth').parentElement.classList.add('d-none');

        if (document.getElementById('first_name').value) document.getElementById('first_name').disabled = true;
        if (document.getElementById('last_name').value) document.getElementById('last_name').disabled = true;
    }
}

export function toggleField(field, toggle) {
    toggleRequiredField(field, toggle);
    field.attr('disabled', !toggle);
    if (!toggle) {
        if (field.prop('type') == 'checkbox') {
            field.prop('checked', false);
        } else {
            field.val('');
        }
        $('label[for="'+field.attr('id')+'"] span.error').text('');
    }
}

export function toggleRequiredField(field, toggle) {
    let validation = field.attr('data-validate').split(' ');

    if (toggle) {
        if (validation.indexOf('required') == -1) {
            validation.push('required');
        }
    } else {
        let index = validation.indexOf('required');
        if (index != -1) {
            validation.splice(index, 1);
        }
    }

    field.attr('data-validate', validation.join(' '));
}

export function customValidateField(field, validation) {
    customToggleFieldError(field, false);
    toggleFieldError(field, false);

    if (field.type == 'radio') {
        var checked = document.querySelector('input[name="'+field.name+'"]:checked');

        if (validation.includes('required') && !checked) {
            customToggleFieldError(field, true, 'Required');
            return false;
        }
    } else if (field.type == 'number') {
        if (validation.includes('required') && !field.value) {
            toggleFieldError(field, true, 'Required');
            return false;
        }
        if (field.value && !validPrice(field)) {
            toggleFieldError(field, true, 'Invalid');
            return false;
        }
        if (field.value && field.getAttribute('min') && parseFloat(field.value) < parseFloat(field.getAttribute('min'))) {
            toggleFieldError(field, true, `Minimum value is ${field.getAttribute('min')}`);
            return false;
        }
        if (field.value && field.getAttribute('max') && parseFloat(field.value) > parseFloat(field.getAttribute('max'))) {
            toggleFieldError(field, true, `Maximum value is ${field.getAttribute('max')}`);
            return false;
        }
    }

    return true;
}

export function customToggleFieldError(field, toggle, message) {
    if (field.type == 'radio') {
        var question = document.querySelector('#'+field.name);
        var span = question.querySelector('span.error');
        var labels = document.querySelectorAll('label[for^="'+field.name+'"]');

        question.classList[toggle ? 'add' : 'remove']('error');
        field.classList[toggle ? 'add' : 'remove']('error');
        span.innerHTML = toggle ? message : '';

        [].forEach.call(labels, function(label) {
            label.classList[toggle ? 'add' : 'remove']('error');
        });
    }
}
